import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  returnFlightDate,
  returnWeeekDay,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import { fullMonths } from '../../../../utils/consts/months';
// importing components
import { TimeComponent } from '../../booking/mobileTicket/timeComponent';
// importing svg-components
import { BaggageIcon } from '~svg';

const MobileFlightSection = (props) => {
  let flightList = [];
  props.currentFlight.flights.itineraries.forEach((item, index) => {
    item.flights.forEach((flight) => {
      flightList.push({ ...flight, itinerariesIndex: index });
    });
  });
  const { name, direction } = props.language;
  const [flights, setFlights] = useState(flightList);
  const [lastPageX, setLastPageX] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);
  useEffect(() => {
    props.changeFlightIndex(flights[slideIndex].itinerariesIndex);
  }, [slideIndex]);

  //when touch element
  const onStartMoveElement = (e, index) => {
    e.stopPropagation();
    // if (index === 0)
    setLastPageX(e.pageX || e.targetTouches[0].pageX);
  };
  // drag element with touch
  const onMoveElement = (e, index) => {
    e.stopPropagation();
    if (index === 0) {
      let offset =
        lastPageX === 0 ? 0 : (e.pageX || e.targetTouches[0].pageX) - lastPageX;

      move(offset);
    }
  };

  // set element how much moved
  const move = (offset) => {
    cssAttribute('left', `${Math.round(offset)}px`);
  };

  // leve element
  const onDropElement = (e, index) => {
    e.stopPropagation();
    if (index === 0) {
      let offset = getleftMargin();
      end(offset);
    }
  };

  // set nimation after drop element
  const end = (offset) => {
    if (offset > CurrentElementHeight() / 4) setAnimation('goToRight');
    else if (offset < -(CurrentElementHeight() / 4)) setAnimation('goToLeft');
    else {
      addCssClass('transition');
      cssAttribute('left', `0px`);
      setTimeout(() => {
        removeCssClass('transition');
      }, 260);
    }
  };
  // set animatoin to element and after time out remove animation
  const setAnimation = (animation, index = undefined) => {
    addCssClass(animation);
    setTimeout(() => {
      cssAttribute('left', `0px`);
      removeCssClass(animation);
      if (index == undefined) {
        if (animation == 'goToRight') {
          direction == 'rtl' ? turnLeftDot() : turnRightDot();
        } else {
          direction == 'rtl' ? turnRightDot() : turnLeftDot();
        }
      } else {
        let shift =
          index - slideIndex > 0 ? index - slideIndex : slideIndex - index;
        let arr = flights;
        for (let i = 0; i < shift; i++)
          index - slideIndex > 0
            ? arr.push(arr.shift())
            : arr.unshift(arr.pop());

        setFlights(arr);
        setSlideIndex(index);
      }
    }, 260);
  };

  const turnLeftDot = () => {
    let n = [];
    for (let i = 1; i < flights.length; i++) n.push(flights[i]);
    setFlights([...n, flights[0]]);
    slideIndex === flights.length - 1
      ? setSlideIndex(0)
      : setSlideIndex(slideIndex + 1);
    props.changeFlightIndex(n.length ? n.itinerariesIndex : 0);
  };

  const turnRightDot = () => {
    let n = [flights[flights.length - 1]];
    for (let i = 0; i < flights.length - 1; i++) n.push(flights[i]);
    setFlights(n);
    slideIndex === 0
      ? setSlideIndex(flights.length - 1)
      : setSlideIndex(slideIndex - 1);
    props.changeFlightIndex(n.length ? n.itinerariesIndex : 0);
  };

  const addCssClass = (cssClass) =>
    document.getElementById('item-flight-0')?.classList.add(cssClass);

  const removeCssClass = (cssClass) => {
    document.getElementById('item-flight-0')?.classList.remove(cssClass);
  };
  const CurrentElementHeight = () =>
    document.getElementById('item-flight-0').offsetWidth;

  const cssAttribute = (key, value) => {
    document.getElementById('item-flight-0').style[key] = value;
  };
  const renderMiladiDate = (date, index) => {
    if (date !== undefined && date !== null && date != '') {
      date = date.split('T')[0].split('-');
      return `${date[2]} ${fullMonths['ltr']['fa'][date[1] - 1]} ${date[0]}`;
    }
  };

  const getleftMargin = () => {
    const leftValue = window.getComputedStyle(
      document.getElementById('item-flight-0'),
    )?.left;
    return parseInt(leftValue.replace('px', ''));
  };

  return (
    <Fragment>
      <div className="d-flex col-12 col-sm-6 px-0 px-sm-2 h-50 h-sm-100 flex-column ">
        <div
          className={`d-flex position-relative w-100 h-100  d-flex justify-content-center align-items-center rounded-lg overflow-hidden `}
        >
          {flights.map((item, index) => (
            <div
              id={`item-flight-${index}`}
              key={`${index}-item-flight`}
              className={`d-flex flex-column border border-secondary-light border-3 position-absolute  justify-content-center align-items-center py-3`}
              style={
                index <= 3
                  ? {
                      // border: "3px solid #00c853",
                      borderRadius: '8px',
                      left: 0,
                      // top: `${(3 - index) * 5}px`,
                      zIndex:
                        index == 0 ? flights.length : flights.length - index,
                      width: `calc(100% - ${index * 8}px)`,
                      opacity: `${index === 0 ? 1 : 1 - (index + 1) / 7}`,
                      // height: `calc(100% - ${(3 - index) * 5}px)`,
                      background: '#ffffff',
                    }
                  : {
                      position: 'absolute',
                      zIndex: flights.length - index,
                      opacity: 0,
                    }
              }
            >
              {/* -------------------------------------------------------------------------------------------------------------- */}
              <div className="d-flex w-100 text-dark">
                <div className="d-flex align-items-center justify-content-start flex-column h-100 col-2 font-weight-bold">
                  <div className="d-flex justify-content-center align-items-center  w-100 ">
                    <img
                      className={`d-flex justify-content-center`}
                      style={{ width: 32, height: 32 }}
                      src={returnAirlineLogos(item.operatingAirline.code)}
                      alt="operatingAirline"
                    />
                  </div>
                  <div className="d-flex justify-content-center align-items-center font-weight-bold text-gray  w-100 font-smaller py-2">
                    {item.operatingAirline.name[name]}
                  </div>
                </div>

                <div className="d-flex  col-6 mx-5  justify-content-center ">
                  <div className="d-flex justify-content-center align-items-start pt-3  w-100  font-smaller ">
                    <div className="d-flex justify-content-end align-items-start  font-smaller text-secondary ">
                      {returnWeeekDay(item.departureDateTime, name, false)}
                    </div>
                    <span className="d-flex px-1">
                      {direction === 'rtl' &&
                        returnFlightDate(item.departureDateTime, 'fa', false)}
                    </span>
                    ,
                    {direction === 'rtl' && (
                      <span className="d-flex text-gray-dark px-1 ">
                        {renderMiladiDate(item.departureDateTime)}
                      </span>
                    )}
                    {direction === 'ltr' && (
                      <span className="d-flex ">
                        {returnFlightDate(item.departureDateTime, 'en', false)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {/* -------------------------------------------------------------------------------------------------------------- */}
              <div className="d-flex w-100 ">
                {/* <div className="d-flex align-items-center justify-content-start flex-column h-100 w-100 font-weight-bold">
                  <div className="d-flex justify-content-center align-items-center  w-100 ">
                    <img
                      className={`d-flex justify-content-center`}
                      style={{ width: 32, height: 32 }}
                      src={returnAirlineLogos(item.operatingAirline.code)}
                    />
                  </div>
                  <div className="d-flex justify-content-center align-items-center font-weight-bold text-secondary  w-100 font-smaller py-2">
                    {item.operatingAirline.name[name]}
                  </div>
                </div> */}
              </div>
              {/* ------------------------------------------------------------------------------------------ */}
              <div className="d-flex w-100 justify-content-between align-items-center pt-1"></div>
              {/* -------------------------------------------------------------------------------- */}
              <div className="d-flex w-100 justify-content-between align-items-center ">
                <div className="d-flex col-4 p-0 justify-content-center align-items-center  text-secondary font-xlarge">
                  <div className="d-flex flex-column w-100  flight-font">
                    <div className="d-flex justify-content-center align-items-center text-primary-light w-100  ">
                      {item.departureAirport.cityName[name]}
                    </div>
                    <div className="d-flex justify-content-center align-items-center text-gold w-100  ">
                      {item.departureDateTime.split('T')[1].substring(0, 5)}
                    </div>

                    <div className="d-flex justify-content-center px-1 align-items-center font-smaller text-primary pt-1  w-100 text-truncate">
                      {item.departureAirport.name[name]
                        .replace('Airport', '')
                        .replace('فرودگاه', '')}
                    </div>
                    <div className="d-flex justify-content-center align-items-center font-smaller text-third  pt-1  w-100 ">
                      {item.departureAirport.terminal
                        ? `${props.intl.formatMessage({
                            id: 'booking.terminal',
                          })} ${item.departureAirport.terminal}`
                        : props.intl.formatMessage({
                            id: 'booking.mainterminal',
                          })}
                    </div>
                  </div>
                </div>
                <div className="d-flex col-4 p-0 d-flex flex-column">
                  <div className="d-flex justify-content-center align-items-center pb-2 px-2 m-0 w-100 text-primary">
                    <span
                      className={`p-1 font-weight-bold font-smaller text-primary ${
                        props.currentFlight.flights.itineraries[
                          item.itinerariesIndex
                        ].isCharte
                          ? 'text-danger'
                          : 'systemType-text'
                      }  `}
                    >
                      <FormattedMessage
                        id={`booking.${
                          props.currentFlight.flights.itineraries[
                            item.itinerariesIndex
                          ].isCharter
                            ? 'charter'
                            : 'systemic'
                        }`}
                        defaultMessage={`booking.${
                          props.currentFlight.flights.itineraries[
                            item.itinerariesIndex
                          ].isCharter
                            ? 'charter'
                            : 'systemic'
                        }`}
                      />
                    </span>
                    <span
                      className={`font-smaller py-1 ${
                        item.resBookDesigCabinName['en'] === 'Economy'
                          ? 'text-primary  '
                          : 'text-warning'
                      } font-weight-bold `}
                    >
                      {` ${item.resBookDesigCabinName[name]}`}
                    </span>
                  </div>
                  <TimeComponent
                    direction={direction}
                    intl={props.intl}
                    flightDuration={item.flightDuration.substring(0, 5)}
                  />
                  <div className="d-flex justify-content-center align-items-center pt-3  text-primary w-100 font-smaller">
                    <span className="text-secondary px-1">
                      <FormattedMessage id="creditTicket.allowableload" />
                    </span>
                    :
                    {item.baggage && item.baggage.length > 0 ? (
                      item.baggage
                        .filter((bag) => bag.type === 'ADT')[0]
                        .unit.toLowerCase() === 'kg' &&
                      item.baggage.filter((bag) => bag.type === 'ADT')[0]
                        .quantity > 0 ? (
                        `${
                          item.baggage.filter((bag) => bag.type === 'ADT')[0]
                            .quantity
                        }  ${props.intl.formatMessage({
                          id: 'booking.kg',
                        })}`
                      ) : item.baggage.filter((bag) => bag.type === 'ADT')[0]
                          .quantity > 0 ? (
                        <Tooltip
                          id={`baggageDesc-${index}`}
                          position={'top'}
                          content={`${
                            item.baggage.filter((bag) => bag.type === 'ADT')[0]
                              .quantity
                          } * ${
                            item.resBookDesigCabinName['en']
                              .toLowerCase()
                              .includes('economy')
                              ? 23
                              : 32
                          } ${props.intl.formatMessage({
                            id: 'booking.kg',
                            defaultMessage: 'booking.kg',
                          })}`}
                          direction={direction}
                          backgroundColor="warning"
                          textColor="dark"
                        >
                          <span>
                            <BaggageIcon size={12} color="#00798c" />,
                            {`${
                              //just show baggage of adult
                              item.baggage.filter(
                                (bag) => bag.type === 'ADT',
                              )[0].quantity
                            } ${props.intl.formatMessage({
                              id:
                                'booking.' +
                                item.baggage
                                  .filter((bag) => bag.type === 'ADT')[0]
                                  .unit.toLowerCase(),
                              defaultMessage:
                                'booking.' +
                                item.baggage
                                  .filter((bag) => bag.type === 'ADT')[0]
                                  .unit.toLowerCase(),
                            })}`}
                          </span>
                        </Tooltip>
                      ) : (
                        props.intl.formatMessage({
                          id: 'booking.nobaggage',
                          defaultMessage: 'booking.nobaggage',
                        })
                      )
                    ) : (
                      '--'
                    )}
                  </div>
                </div>
                <div className="d-flex col-4 p-0  justify-content-center align-items-center font-xlarge text-secondary">
                  <div className="d-flex flex-column w-100  flight-font font-weight-bold">
                    <div className="d-flex justify-content-center align-items-center  w-100 text-primary-light">
                      {item.arrivalAirport.cityName[name]}
                    </div>
                    <div className="d-flex justify-content-center align-items-center text-gold w-100  ">
                      {item.arrivalDateTime.split('T')[1].substring(0, 5)}
                    </div>
                    <div className="d-flex justify-content-center align-items-center font-smaller text-primary pt-1 px-1 w-100 text-truncate">
                      {item.arrivalAirport.name[name]
                        .replace('Airport', '')
                        .replace('فرودگاه', '')}
                    </div>
                    <div className="d-flex justify-content-center align-items-center font-smaller text-third  pt-1  w-100 ">
                      {item.arrivalAirport.terminal
                        ? `${props.intl.formatMessage({
                            id: 'booking.terminal',
                          })} ${item.arrivalAirport.terminal}`
                        : props.intl.formatMessage({
                            id: 'booking.mainterminal',
                          })}
                    </div>
                  </div>
                </div>
              </div>
              {/* -------------------------------------------------------------------------------------- */}
              <div className="d-flex w-100 mt-3 font-weight-bold">
                {/* <div className="d-flex flex-column w-100 justify-content-center">
                  <div className="d-flex justify-content-center align-items-center  w-100 font-smaller text-primary">
                    {returnWeeekDay(item.departureDateTime, name, false)}
                  </div>
                  <div className="d-flex justify-content-center align-items-center flex-column w-100  font-smaller">
                    <span className="d-flex ">
                      {direction === "rtl" &&
                        returnFlightDate(item.departureDateTime, "fa", false)}
                    </span>
                    {direction === "rtl" && (
                      <span className="d-flex text-gray ">
                        {renderMiladiDate(item.departureDateTime)}
                      </span>
                    )}
                    {direction === "ltr" && (
                      <span className="d-flex ">
                        {returnFlightDate(item.departureDateTime, "en", false)}
                      </span>
                    )}
                  </div>
                </div> */}

                <div className="d-flex w-100  justify-content-center pt-5">
                  <div className="d-flex  justify-content-start align-items-start pt-2 text-dark col-6 px-4 font-smaller">
                    <span className="px-1">
                      <FormattedMessage id="creditTicket.equipmentname" />
                    </span>
                    :
                    <span className="px-1 text-primary-light">
                      {item.equipment.name[name]}
                    </span>
                  </div>
                  <div className="w-100 px-2">
                    <div className="text-danger font-smaller text-dark  d-flex justify-content-center pb-2 ">
                      <span className="px-1">
                        <FormattedMessage id="creditTicket.Cabinname" />
                      </span>
                      :
                      <span className="px-1 text-primary-light">
                        {`${item.resBookDesigCabinName[name]}`}
                        {/* .flights.itineraries.flights.resBookDesigCabinName */}
                      </span>
                    </div>
                    <div className="d-flex justify-content-center align-items-end  font-smaller pt-2">
                      <span className="px-1  text-dark">
                        <FormattedMessage id="creditTicket.flightnumber" />
                      </span>
                      <span className="text-dark">:</span>
                      <span className="px-1 text-primary-light">
                        {item.flightNumber}
                      </span>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex flex-column w-100 justify-content-center">
                  <div className="d-flex justify-content-center align-items-center  w-100 font-smaller text-primary">
                    {returnWeeekDay(item.arrivalDateTime, name, false)}
                  </div>
                  <div className="d-flex justify-content-center align-items-center flex-column w-100 font-smaller">
                    <span className="d-flex ">
                      {direction === "rtl" &&
                        returnFlightDate(item.arrivalDateTime, "fa", false)}
                    </span>
                    {direction === "rtl" && (
                      <span className="d-flex text-gray ">
                        {renderMiladiDate(item.arrivalDateTime)}
                      </span>
                    )}
                    {direction === "ltr" && (
                      <span className="d-flex ">
                        {returnFlightDate(item.arrivalDateTime, "en", false)}
                      </span>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex w-100 justify-content-center">
          {flights.length > 1 &&
            flights.map((item, index) => (
              <span
                key={index}
                onClick={() => {
                  slideIndex != index &&
                    setAnimation(
                      direction === 'ltr'
                        ? index > slideIndex
                          ? 'goToRight'
                          : 'goToLeft'
                        : index > slideIndex
                        ? 'goToLeft'
                        : 'goToRight',
                      index,
                    );
                }}
                className={`dot  ${slideIndex === index ? 'bg-dark' : ''}`}
              />
            ))}
        </div>
      </div>
    </Fragment>
  );
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps, {})(MobileFlightSection));
